var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tab.Assets && _vm.tab.Assets.length > 0 || _vm.SampleOnly)?_c('v-carousel',{attrs:{"height":"400"}},_vm._l((_vm.RenderedGalleryAssets),function(picture){return _c('v-carousel-item',{key:picture.itemObjKey},[_c('v-img',{attrs:{"src":picture.ThumbURL,"height":"100%"}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }